import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AddCustomerModalState {
  isAddCustomerModalOpen: boolean;
  transactionAccountId?: string;
  shouldAllowMultipleAddresses?: boolean;
  shouldAllowCreatingBillingProfile?: boolean;
  onSuccess?: () => void;
}

export interface AddCustomerModalPayload {
  transactionAccountId?: string;
  shouldAllowMultipleAddresses?: boolean;
  shouldAllowCreatingBillingProfile?: boolean;
  onSuccess?: () => void;
}

export const initialState: AddCustomerModalState = {
  isAddCustomerModalOpen: false,
};

export const addCustomerModal = createSlice({
  name: 'app/addCustomerModal',
  initialState,
  reducers: {
    openAddCustomerModal(state, action?: PayloadAction<AddCustomerModalPayload>) {
      state.isAddCustomerModalOpen = true;
      if (action?.payload?.transactionAccountId) {
        state.transactionAccountId = action.payload.transactionAccountId;
        state.shouldAllowMultipleAddresses = action.payload.shouldAllowMultipleAddresses;
        state.shouldAllowCreatingBillingProfile = action.payload.shouldAllowCreatingBillingProfile;
        state.onSuccess = action.payload.onSuccess;
      }
    },
    closeAddCustomerModal(state) {
      state.isAddCustomerModalOpen = false;
    },
  },
});

export const actions = addCustomerModal.actions;

export const { openAddCustomerModal, closeAddCustomerModal } = addCustomerModal.actions;

export default addCustomerModal.reducer;

export const addCustomerModalState = (state: any) => state?.addCustomerModal;
